<template>
  <header
    class="app-header header__shadow"
    :class="{
      'app-header--stato-servizi': mostraRapido || mostraPediatrico,
      'app-header--stato-servizi-entrambi': mostraRapido && mostraPediatrico,
    }"
  >
    <div class="app-header__title">
      <h1>{{ routeLabel }}</h1>
      <p v-if="isFever" class="app-header__sub text-left">Piattaforma in modalità eCRF</p>
    </div>
    <!-- Stato ON/OFF dell'operatore sul rapido e sul pediatrico: fuori dagli
         strumenti perché, dove accanto al titolo e al menu utente non entra,
         va su una riga sua (_chrome.scss) -->
    <div
      v-if="mostraRapido || mostraPediatrico"
      class="app-header__stato-servizi"
    >
      <OperatorServiceStatusSwitch
        v-if="mostraRapido"
        :serviceref="10"
      ></OperatorServiceStatusSwitch>
      <OperatorServiceStatusSwitch
        v-if="mostraPediatrico"
        :serviceref="11"
      ></OperatorServiceStatusSwitch>
    </div>
    <div class="app-header__tools">
      <template v-if="user.company.level !== 5">
        <PopupNotificationComponent></PopupNotificationComponent>
      </template>
      <!-- Menu dell'utente, come nel cittadino: il nome in alto a destra e
           l'uscita qui dentro, non più in fondo alla navigazione. -->
      <b-dropdown id="header-submenu" variant="white" right class="app-header__menu app-header__user">
        <template #button-content>
          <b-avatar size="sm" variant="secondary" :text="userInitials" aria-hidden="true"></b-avatar>
          <span class="app-header__menu-text" :class="{ 'text-capitalize': hasFullName }">{{ welcomeName }}</span>
        </template>
        <b-dropdown-item @click.prevent="$bvModal.show('logout-confirm')">
          <b-icon icon="door-open" aria-hidden="true" class="mr-2"></b-icon>{{ $t('esci') }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <!-- <div class="ml-auto text-right d-flex align-items-center">
      <h5 class="mr-2">{{ currentTime }}</h5>
      <h5>{{ currentDate }}</h5> 
    </div> -->
  </header>
</template>
<script>
import { OPERATORE_ROUTE_NAMES } from "@/_utils/constants.js";
import { mapState } from "vuex";
import OperatorServiceStatusSwitch from "@/app/modules/impostazioni/components/utente/OperatorServiceStatusSwitch.vue";
import PopupNotificationComponent from "@/app/layout/components/PopupNotificationComponent.vue";

export default {
  name: "OperatoreTopHeader",
  components: { OperatorServiceStatusSwitch, PopupNotificationComponent },
  methods: {
    companyHasService(ref) {
      if (this.company) {
        return this.company.active_services.find(
          (el) => el.position_ref === ref
        )
          ? true
          : false;
      }
      return false;
    },
  },
  computed: {
    ...mapState("company", ["company"]),
    ...mapState("utente", ["status", "user"]),
    ...mapState("settings", ["activeRefs", "userSubscriptionNeeds"]),
    mostraRapido() {
      return (
        this.user.company.level !== 5 &&
        this.activeRefs.includes(10) &&
        this.companyHasService(10) &&
        this.user.permessi.includes("gestire teleconsulto di emergenza")
      );
    },
    mostraPediatrico() {
      return (
        this.user.company.level !== 5 &&
        this.activeRefs.includes(11) &&
        this.companyHasService(11) &&
        this.user.permessi.includes("gestire teleconsulto pediatrico")
      );
    },
    // Senza anagrafica il ripiego è lo username, che spesso è un indirizzo di
    // posta: capitalizzarlo lo renderebbe "Paolo+Centroderm@Qwince.Com"
    hasFullName() {
      return !!(
        this.user &&
        this.user.anagrafica &&
        (this.user.anagrafica.name || this.user.anagrafica.surname)
      );
    },
    welcomeName() {
      if (this.hasFullName) {
        return [this.user.anagrafica.name, this.user.anagrafica.surname].filter(Boolean).join(' ');
      }
      return this.user.username;
    },
    // Iniziali per l'avatar nell'header (solo presentazione)
    userInitials() {
      return String(this.welcomeName || "")
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p.charAt(0))
        .join("")
        .toUpperCase();
    },
    routeLabel() {
      try {
        const label = this.routeNames[this.$route.name];
        if (label === undefined) {
          throw "label not found";
        } else if (this.$route.name === "teleconsulto") {
          return label + " " + this.$route.params.section;
        }
        return label;
      } catch (err) {
        if (this.isFever) {
          return "Benvenuto nel Progetto FEVER";
        }
        return `Benvenuto in ${this.appName}`;
      }
    },
    isFever() {
      return this.company && this.company.projects_with_free_services
        ? this.company.projects_with_free_services.some(
            (el) => el.name === "FEVER"
          )
        : false;
    },
  },
  data() {
    return {
      routeNames: OPERATORE_ROUTE_NAMES,
      appName: process.env.VUE_APP_APP_NAME,
    };
  },
};
</script>
